// Generated by ts-to-zod
import { z } from 'zod';
import { paginationQuerySchema } from '../../utils/listQuery.schema';

export const noteSchema = z.object({
  id: z.number(),
  url: z.string(),
  type: z.union([
    z.literal('rejection'),
    z.literal('postponement'),
    z.literal('comment'),
  ]),
  metadata: z.record(z.unknown()),
  content: z.string(),
  createdAt: z.string(),
  creator: z.string(),
  modifiedAt: z.string().nullable(),
  modifier: z.string().nullable(),
  annotation: z.string(),
});

export const notesListQuerySchema = paginationQuerySchema.and(
  z
    .object({
      annotation: z.number(),
      creator: z.string(),
      ordering: z.string(),
    })
    .partial()
);

export const createNotePayloadSchema = noteSchema.pick({
  annotation: true,
  content: true,
  type: true,
});

export const patchNotePayloadSchema = noteSchema.pick({ content: true });
